module.exports = __webpack_public_path__ + "b55b1345f0b919f0cab774ec25d6654e.woff2";